import * as React from 'react';

export const FileRTFIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="35"
    height="45"
    viewBox="0 0 35 45"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    focusable="false"
    {...props}
  >
    <g opacity="0.3">
      <path
        opacity="0.3"
        d="M29.0979 10.2604C27.9589 10.2593 26.8669 9.80634 26.0615 9.00096C25.2562 8.19557 24.8032 7.10355 24.8021 5.96456V0H5.60627C2.51003 0 1.60933e-05 2.51 1.60933e-05 5.60623V39.4021C0.00461092 42.4932 2.5151 45 5.60627 45H28.6479C29.3843 45.0003 30.7292 45 30.7292 45H32.5C33.47 45 34.2563 44.2144 34.2563 43.2444C34.2563 41.7705 34.2563 39.8362 34.2563 39.3938V10.2521L29.0979 10.2604Z"
        fill="#76A9FA"
      />
    </g>
    <path
      d="M34.2566 10.2604H29.0982C27.9593 10.2593 26.8672 9.80634 26.0618 9.00096C25.2565 8.19557 24.8035 7.10355 24.8024 5.96456V0L34.2566 10.2604Z"
      fill="#76A9FA"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.7182 15.6459V29.353C10.7301 29.362 10.7547 29.3745 10.7931 29.3745H23.3748C23.4131 29.3745 23.4378 29.362 23.4497 29.353V15.6459C23.4378 15.6369 23.4131 15.6245 23.3748 15.6245H10.7931C10.7547 15.6245 10.7301 15.6369 10.7182 15.6459ZM9.1904 15.6245C9.1904 14.715 9.97674 14.0967 10.7931 14.0967H23.3748C24.1911 14.0967 24.9774 14.715 24.9774 15.6245V29.3745C24.9774 30.2839 24.1911 30.9022 23.3748 30.9022H10.7931C9.97674 30.9022 9.1904 30.2839 9.1904 29.3745V15.6245ZM12.246 17.9161C12.246 17.4942 12.588 17.1522 13.0099 17.1522H21.158C21.5799 17.1522 21.9219 17.4942 21.9219 17.9161C21.9219 18.338 21.5799 18.68 21.158 18.68H13.0099C12.588 18.68 12.246 18.338 12.246 17.9161ZM12.246 20.9717C12.246 20.5498 12.588 20.2078 13.0099 20.2078H21.158C21.5799 20.2078 21.9219 20.5498 21.9219 20.9717C21.9219 21.3936 21.5799 21.7356 21.158 21.7356H13.0099C12.588 21.7356 12.246 21.3936 12.246 20.9717ZM12.246 24.0272C12.246 23.6054 12.588 23.2633 13.0099 23.2633H17.5932C18.0151 23.2633 18.3571 23.6054 18.3571 24.0272C18.3571 24.4491 18.0151 24.7911 17.5932 24.7911H13.0099C12.588 24.7911 12.246 24.4491 12.246 24.0272Z"
      fill="#76A9FA"
    />
    <rect
      x="6.87485"
      y="33.3335"
      width="20.8333"
      height="7.69176"
      rx="1.5625"
      fill="#76A9FA"
    />
    <path
      d="M10.7374 38.4779C11.0369 38.4779 11.2797 38.7207 11.2797 39.0202C11.2797 39.3197 11.0369 39.5625 10.7374 39.5625H10.6986C10.3991 39.5625 10.1563 39.3197 10.1563 39.0202C10.1563 38.7207 10.3991 38.4779 10.6986 38.4779H10.7374Z"
      fill="white"
    />
    <path
      d="M24.0675 34.7654V35.6866H22.1057V36.7351H23.6204V37.615H22.1057V39.5497H20.9474V34.7654H24.0675Z"
      fill="white"
    />
    <path
      d="M19.9238 34.7654V35.6866H18.6239V39.5497H17.4608V35.6866H16.1736V34.7654H19.9238Z"
      fill="white"
    />
    <path
      d="M14.1755 39.5506L13.1397 37.7431H12.8756V39.5506H11.7188V34.7662H13.695C14.024 34.7572 14.3507 34.8242 14.6496 34.9619C14.895 35.0786 15.1 35.2658 15.2383 35.4997C15.3715 35.7387 15.4391 36.0088 15.434 36.2825C15.4433 36.6023 15.3416 36.9155 15.146 37.1687C14.933 37.426 14.6381 37.6023 14.3107 37.6683L15.4484 39.5506H14.1755ZM12.8756 36.9523H13.5931C13.7764 36.9661 13.9581 36.9092 14.1007 36.7932C14.1572 36.7334 14.2006 36.6625 14.228 36.585C14.2554 36.5074 14.2662 36.425 14.2598 36.3429C14.2651 36.2615 14.2537 36.1799 14.2264 36.103C14.199 36.0261 14.1562 35.9556 14.1007 35.8959C13.96 35.7786 13.7788 35.7215 13.5963 35.7368H12.8787L12.8756 36.9523Z"
      fill="white"
    />
  </svg>
);

export default FileRTFIcon;
